import React from 'react';
import { PillStyles as S } from './Pill.styles';
const Pill = ({ text, onTagClick, active, theme = 'black', size = 'standard', ...rest }) => {
    return (React.createElement(S.Container, { ...rest, onClick: () => onTagClick && onTagClick(), "data-active": active, "data-background": theme, "data-size": size, type: "button" }, text));
};
export default Pill;
